import { render, staticRenderFns } from "./index.vue?vue&type=template&id=032bd1f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=032bd1f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032bd1f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032bd1f0')) {
      api.createRecord('032bd1f0', component.options)
    } else {
      api.reload('032bd1f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=032bd1f0&scoped=true", function () {
      api.rerender('032bd1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderSearch/index.vue"
export default component.exports